/*
  C Lockdown — shows sections/c-lockdown.liquid when Wholesale Lock locks the page.

  The app decides the lock in its own JS (/apps/wlm/js/wlm-1.1.js). On a full-page lock it
  removes `.wlm-content` and drops the inline `display: none` from #wlm-pwd-form. That is the
  signal we wait for. The form keeps its ids, so wlm.unlockByAuth() and the app's own
  wrong-password message keep working after it moves into the card.

  ?c_lockdown_preview=1 opens the page with a demo form for QA, without a live lock.
*/
(function () {
  var root = document.getElementById('CLockdown');
  if (!root) return;

  var slot = root.querySelector('[data-c-lockdown-slot]');
  var data = root.dataset;
  var opened = false;

  function isFullPageLock(form) {
    return (
      form &&
      !form.hasAttribute('style') &&
      !document.querySelector('.wlm-content') &&
      !form.closest('form')
    );
  }

  function skinForm(form) {
    var input = form.querySelector('#wlm-pwd');
    var button = form.querySelector('#wlm-pwd-form-button');
    var error = form.querySelector('#wlm-pwd-error');

    if (input) {
      if (data.placeholder) input.setAttribute('placeholder', data.placeholder);
      input.setAttribute('aria-label', data.placeholder || 'Password');
      input.setAttribute('autocomplete', 'off');

      var field = document.createElement('div');
      field.className = 'c-lockdown__field';
      input.parentNode.insertBefore(field, input);
      field.appendChild(input);

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'c-lockdown__toggle';
      toggle.textContent = data.showLabel || 'Show';
      toggle.setAttribute('aria-pressed', 'false');
      toggle.addEventListener('click', function () {
        var reveal = input.type === 'password';
        input.type = reveal ? 'text' : 'password';
        toggle.textContent = reveal ? data.hideLabel || 'Hide' : data.showLabel || 'Show';
        toggle.setAttribute('aria-pressed', String(reveal));
        input.focus();
      });
      field.appendChild(toggle);
    }

    if (button) {
      if (data.buttonLabel) button.textContent = data.buttonLabel;
      button.setAttribute('role', 'button');
    }

    if (error) {
      if (data.errorText) error.textContent = data.errorText;
      error.setAttribute('role', 'alert');
    }
  }

  function open(form) {
    if (opened) return;
    opened = true;

    slot.appendChild(form);
    skinForm(form);

    // c-lockdown.css hides every other child of <body> while this class is on.
    root.hidden = false;
    document.documentElement.classList.add('c-lockdown-open');

    var input = form.querySelector('#wlm-pwd');
    if (input && window.matchMedia('(min-width: 768px)').matches) input.focus({ preventScroll: true });
  }

  function demoForm() {
    var form = document.createElement('div');
    form.id = 'wlm-pwd-form';
    form.innerHTML =
      '<div id="wlm-wrapper"><div class="wlm-form-holder">' +
      '<input type="password" id="wlm-pwd" placeholder="Enter passcode">' +
      '<a href="#" id="wlm-pwd-form-button">Enter password</a>' +
      '</div><div id="wlm-pwd-error" style="display:none">Invalid password</div></div>';
    form.querySelector('#wlm-pwd-form-button').addEventListener('click', function (e) {
      e.preventDefault();
      form.querySelector('#wlm-pwd-error').style.display = 'block';
      form.querySelector('#wlm-pwd').classList.add('wlm-error');
    });
    return form;
  }

  // Keep the section at the end of <body> so the overlay is never trapped in a stacking context.
  if (!root.hasAttribute('data-preview') && root.parentNode !== document.body) {
    document.body.appendChild(root);
  }

  if (root.hasAttribute('data-preview')) {
    slot.appendChild(demoForm());
    skinForm(slot.firstChild);
    return;
  }

  if (/[?&]c_lockdown_preview=1(&|$)/.test(window.location.search)) {
    open(demoForm());
    return;
  }

  var form = document.getElementById('wlm-pwd-form');
  if (!form) return;
  if (isFullPageLock(form)) return open(form);

  // wlm.toggleContent() drops the form's style and removes .wlm-content in the same tick,
  // so watching the style attribute is enough.
  var observer = new MutationObserver(function () {
    if (isFullPageLock(form)) {
      observer.disconnect();
      open(form);
    }
  });
  observer.observe(form, { attributes: true, attributeFilter: ['style'] });
})();
